import { API_URLS } from "app/api/config"
import { createWebSocketConnection } from "../../webSockets"

export function createWebSocketConnectionForTimeslots() {
  return createWebSocketConnection(`${API_URLS.planning}/planning`)
}

export function createWebSocketConnectionForTemplateTimeslots() {
  return createWebSocketConnection(`${API_URLS.planning}/template`)
}

export function createWebSocketConnectionForPersonalPlanning() {
  return createWebSocketConnection(`${API_URLS.planning}/personal_planning`)
}
